import React from "react";
import "./SingleBlog.css";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import SubHeader from "../SubComp/SubHeader/SubHeader";
import { Link } from "react-router-dom";

const SingleBlog = () => {
  return (
    <div>
      <Header />
      <SubHeader title="Blogs" text="Blog Title" width='container' />
      <div className="blog-container py-5">
        <div className="container">
          {/* Banner section */}
          <div>
            <img className="banner-img" src={require("../../Asset/blogsingle/Group 286.png")} alt="" />
          </div>
          <div className="row mt-5">
            {/* Right Container  */}
            <div className="col-md-8 text-white">
              <h1>2022 Art Trends</h1>
              <div className="sub-div">
                <div className="m-2">
                  <small>
                    By{" "}
                    <Link to="/" className="cl-pm">
                      Alvin Kelvin
                    </Link>
                  </small>
                </div>
                <div className="m-2">
                  <small> {new Date().toDateString()}</small>
                </div>
                <div className="m-2">
                  <small>
                    <Link to="/" className="cl-pm">
                      Art News
                    </Link>
                  </small>
                </div>
              </div>
              <div className="sub-div">
                <div>
                  <button className="art-btn me-3">Art</button>
                </div>
                <button className="paint-btn">Paintings</button>
              </div>
            </div>
            <div className="col-md-4 text-white">
              <h1>Share</h1>
              <div className="sub-div">
                <div>
                  <div className="svg-div bg_dark ">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.0008 23.1998C5.81519 23.1998 0.800781 18.1854 0.800781 11.9998C0.800781 5.81422 5.81519 0.799805 12.0008 0.799805C18.1864 0.799805 23.2008 5.81422 23.2008 11.9998C23.2008 18.1854 18.1864 23.1998 12.0008 23.1998ZM12.0008 23.1998V10.3998C12.0008 8.63249 13.4335 7.1998 15.2008 7.1998H16.0008M8.00078 13.5998H16.0008"
                        stroke="white"
                      />
                    </svg>
                  </div>
                </div>
                <div className="svg-div bg_dark ">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M23.1662 2.40039L23.6651 2.36731C23.6518 2.16674 23.5197 1.99364 23.3297 1.92789C23.1398 1.86215 22.9289 1.91655 22.7945 2.06599L23.1662 2.40039ZM22.0687 7.13464C22.0687 6.85849 21.8448 6.63464 21.5687 6.63464C21.2925 6.63464 21.0687 6.85849 21.0687 7.13464H22.0687ZM11.9835 7.26614H11.4835V7.26614L11.9835 7.26614ZM11.9835 8.80039L12.4835 8.80039V8.80039L11.9835 8.80039ZM0.800781 20.0004V19.5004C0.580514 19.5004 0.386192 19.6445 0.322287 19.8553C0.258382 20.0661 0.339948 20.2939 0.523135 20.4162L0.800781 20.0004ZM2.39831 2.40039L2.86657 2.22507C2.7968 2.03873 2.62319 1.91149 2.42449 1.90108C2.2258 1.89066 2.03983 1.99904 1.95096 2.17706L2.39831 2.40039ZM8.78843 16.8004L9.14226 17.1537C9.26462 17.0311 9.31486 16.854 9.27504 16.6854C9.23523 16.5169 9.11103 16.381 8.94677 16.3261L8.78843 16.8004ZM20.3465 3.9578L19.9756 4.29314L20.1558 4.49239L20.4213 4.45216L20.3465 3.9578ZM22.6673 2.43347C22.7508 3.69303 22.6771 4.49667 22.4551 5.12238C22.2369 5.73763 21.8575 6.2311 21.2227 6.83938L21.9146 7.5614C22.5999 6.90471 23.1045 6.28286 23.3976 5.4567C23.687 4.64099 23.752 3.67713 23.6651 2.36731L22.6673 2.43347ZM22.0687 8.30038V7.13464H21.0687V8.30038H22.0687ZM11.4835 7.26614L11.4835 8.80039L12.4835 8.80039L12.4835 7.26614L11.4835 7.26614ZM11.4835 8.80039L11.4835 9.60039L12.4835 9.60039L12.4835 8.80039L11.4835 8.80039ZM16.8417 1.90039C13.8817 1.90039 11.4835 4.30345 11.4835 7.26614H12.4835C12.4835 4.85428 14.4355 2.90039 16.8417 2.90039V1.90039ZM21.0687 8.30038C21.0687 15.3704 15.3464 21.1004 8.28919 21.1004V22.1004C15.9001 22.1004 22.0687 15.9212 22.0687 8.30038H21.0687ZM1.93006 2.57571C2.77297 4.82695 5.9519 9.30039 11.9835 9.30039V8.30039C6.51288 8.30039 3.62119 4.2405 2.86657 2.22507L1.93006 2.57571ZM1.95096 2.17706C0.305161 5.47375 0.0690007 8.63234 1.24162 11.3015C2.4125 13.9667 4.94421 16.0441 8.6301 17.2747L8.94677 16.3261C5.44377 15.1567 3.18289 13.2341 2.15716 10.8993C1.13318 8.56845 1.2964 5.72703 2.84566 2.62372L1.95096 2.17706ZM8.43461 16.4471C7.43312 17.4502 4.46466 19.5004 0.800781 19.5004V20.5004C4.80505 20.5004 8.01374 18.284 9.14226 17.1537L8.43461 16.4471ZM20.7173 3.62246C19.7617 2.56561 18.379 1.90039 16.8417 1.90039V2.90039C18.0844 2.90039 19.2014 3.43691 19.9756 4.29314L20.7173 3.62246ZM20.4213 4.45216C21.5668 4.27868 22.6919 3.67521 23.5379 2.73479L22.7945 2.06599C22.0973 2.841 21.1793 3.32597 20.2716 3.46344L20.4213 4.45216ZM0.523135 20.4162C3.06243 22.1117 5.72426 22.1004 8.28919 22.1004V21.1004C5.69122 21.1004 3.33172 21.0891 1.07843 19.5846L0.523135 20.4162Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div className="svg-div bg_dark ">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.6008 5.5998H19.2008M7.20078 0.799805H16.8008C20.3354 0.799805 23.2008 3.66518 23.2008 7.1998V16.7998C23.2008 20.3344 20.3354 23.1998 16.8008 23.1998H7.20078C3.66616 23.1998 0.800781 20.3344 0.800781 16.7998V7.1998C0.800781 3.66518 3.66616 0.799805 7.20078 0.799805ZM12.0008 16.7998C9.34981 16.7998 7.20078 14.6508 7.20078 11.9998C7.20078 9.34884 9.34981 7.1998 12.0008 7.1998C14.6517 7.1998 16.8008 9.34884 16.8008 11.9998C16.8008 14.6508 14.6517 16.7998 12.0008 16.7998Z"
                      stroke="white"
                    />
                  </svg>
                </div>
                <div className="svg-div bg_dark text-center">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.20078 21.5998L12.0008 10.3998M6.82301 15.1998C6.06295 14.3506 5.60078 13.2292 5.60078 11.9998V11.1998C5.60078 8.10701 8.10799 5.5998 11.2008 5.5998H12.8008C15.8936 5.5998 18.4008 8.10701 18.4008 11.1998V11.9998C18.4008 14.6508 16.2517 16.7998 13.6008 16.7998C12.1675 16.7998 10.8951 15.8827 10.4418 14.523L10.4008 14.3998M12.0008 23.1998C5.81519 23.1998 0.800781 18.1854 0.800781 11.9998C0.800781 5.81422 5.81519 0.799805 12.0008 0.799805C18.1864 0.799805 23.2008 5.81422 23.2008 11.9998C23.2008 18.1854 18.1864 23.1998 12.0008 23.1998Z"
                      stroke="white"
                    />
                  </svg>
                </div>
                <div className="svg-div bg_dark ">
                  <svg
                    className="align-middle "
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.74273 1.63776C13.0963 8.10454 15.8963 14.3132 16.8702 22.089M0.853076 10.9113C10.4296 10.6912 15.8961 9.17965 20.006 4.16692M4.3208 20.1516C9.47475 12.3077 15.7945 11.1117 23.128 13.2816M23.2008 11.9998C23.2008 5.81448 18.1861 0.799805 12.0008 0.799805C5.81546 0.799805 0.800781 5.81448 0.800781 11.9998C0.800781 18.1851 5.81546 23.1998 12.0008 23.1998C18.1861 23.1998 23.2008 18.1851 23.2008 11.9998Z"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div className="row text-white mt-5">
            <div className="col-md-8">
              <small>
                As we settle into the new year, contemplate our resolutions, and
                perhaps gear up for some redecorating, now is the perfect time
                to refresh your art collection with the latest trending art by
                emerging artists. Our team of curators and art advisors work
                with thousands of artists and collectors throughout the year to
                determine the latest and best of contemporary art. Read on to
                discover the trends that have caught their attention and that
                promise to make a timeless addition to any art collection.
              </small>
              <br />
              <br />
              <small>
                With irresistible and unexpected compositions of human figures
                juxtaposed with flora, floral figures have become a prevalent
                subject for artists working across mediums. Surrealist art
                aficionados will appreciate the dreamlike quality of this trend,
                which has undoubtedly taken off for its reinvention of
                time-honored subjects: the human form and nature. Inherently
                poetic and evocative of nature, floral heads, silhouettes, and
                bodies intertwined with botanicals can infuse your space with a
                timeless sense of romanticism. This art trend expresses a desire
                to get back to nature and exudes feelings of harmony, fantasy,
                and whimsy, from Marlies Plank’s cheeky photography to Karenina
                Fabrizzi’s elegant silhouettes.{" "}
              </small>
              {/* Comment Section  */}
              <h4 className="pt-4">
                Leave a Comment<span className="cl-pm">&nbsp;(21)</span>
              </h4>
              <div className="row mt-5">
                <div className="col-md-2">
                  <img
                    src={require("../../Asset/blogsingle/Ellipse 33.png")}
                    alt="profile"
                  />
                </div>
                <div className="col-md-10 blog-input-div">
                  <input
                    style={{ height: "77px" }}
                    className="form-control form-control-lg mb-3"
                    type="text"
                    placeholder="Write here your comment"
                    aria-label=".form-control-lg example"
                  ></input>
                  <div className="text-end blog-btn-div">
                    <button className="contact-button ">Submit</button>
                  </div>
                </div>
              </div>

              <div className="row mt-5">
                <div className="col-md-2">
                  <img
                    src={require("../../Asset/blogsingle/Ellipse 33.png")}
                    alt="profile "
                  />
                </div>
                <div className="col-md-10 blog-input-div">
                  <div className="d-flex justify-content-between">
                    <div>
                      <small className="cl-pm ">Rajesh chaterji</small>
                      <br />
                    </div>
                    <div>
                      <small style={{ color: "#747474" }}>
                        {" "}
                        {new Date().toDateString()}
                      </small>
                    </div>
                  </div>
                  <small>
                    Across these new trends in art, there is a persistent flair
                    for the unexpected, be it a punch of neon, a surreal floral
                    head, whimsical animal portrait, or wandering astronaut. As
                    we embark on a new year, artists and collectors alike are
                    looking for ways to enliven their spaces and create a window
                    into the extraordinary.{" "}
                  </small>
                  <br />

                  <div className="mt-3">
                    <img
                      src={require("../../Asset/icon/heart.png")}
                      alt="heart icon"
                    />
                    <small className="ps-3">23</small>
                    <Link to="/" className="cl-pm ps-3">
                      Reply
                    </Link>
                  </div>
                  <div className="row mt-5 blog-input-div">
                    <div className="col-md-2">
                      <img
                        src={require("../../Asset/blogsingle/Ellipse 33.png")}
                        alt="profile "
                      />
                    </div>
                    <div className="col-md-10 ">
                      <input
                        style={{ height: "77px" }}
                        className="form-control form-control-lg mb-3"
                        type="text"
                        placeholder="Write here your comment"
                        aria-label=".form-control-lg example"
                      ></input>
                    </div>
                  </div>
                  <div className="text-end blog-btn-div">
                    <button className="contact-button ">Submit</button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card card-div2 mb-3">
                <img
                  src={require("../../Asset/blogsingle/Group 283.png")}
                  className="card-img-top"
                  alt="..."
                />
                <div className="card-body overflow-hidden">
                  <h5 className="card-title">
                    Surrealist Storytelling with Cam Collins
                  </h5>
                  <small className="card-text">
                    We’re finalizing our artist list for Spring 2022, but we
                    just had to give ...
                  </small>
                </div>
              </div>
              <div className="card card-div2 mb-3">
                <img
                  src={require("../../Asset/blogsingle/Group 284.png")}
                  className="card-img-top"
                  alt="..."
                />
                <div className="card-body overflow-hidden">
                  <h5 className="card-title">
                    unexpected compositions of human figures with flora
                  </h5>
                  <small className="card-text">
                    We’re finalizing our artist list for Spring 2022, but we
                    just had to give ...
                  </small>
                </div>
              </div>
              <div className="card card-div2 mb-3">
                <img
                  src={require("../../Asset/blogsingle/Group 285.png")}
                  className="card-img-top"
                  alt="..."
                />
                <div className="card-body overflow-hidden">
                  <h5 className="card-title">
                    Surrealist Storytelling with Cam Collins
                  </h5>
                  <small className="card-text">
                    We’re finalizing our artist list for Spring 2022, but we
                    just had to give ...
                  </small>
                </div>
              </div>
            </div>
          </div>
          <div className="headeing d-flex justify-content-between align-items-center my-5">
            <h1 className="text-white m-0">Similar News</h1>
            <Link className='cl-pm' to="/">View All</Link>
          </div>
          <div className="row pb-5">
            <div className=" col-lg-4 col-md-4 col-sm-6 ">
              <div className="card card-div">
                <img
                  src={require("../../Asset/blog/Group 232 (5).png")}
                  className="card-img-top"
                  alt="..."
                />
                <div className="card-body">
                  <h5 className="card-title">
                    Surrealist Storytelling with Cam Collins
                  </h5>
                  <p className="card-text">
                    We’re finalizing our artist list for Spring 2022, but we
                    just had to give ...
                  </p>
                </div>
              </div>
            </div>
            <div className=" col-lg-4 col-md-4 col-sm-6 ">
              <div className="card card-div">
                <img
                  src={require("../../Asset/blog/Group 232 (6).png")}
                  className="card-img-top"
                  alt="..."
                />
                <div className="card-body">
                  <h5 className="card-title">
                    Surrealist Storytelling with Cam Collins
                  </h5>
                  <p className="card-text">
                    We’re finalizing our artist list for Spring 2022, but we
                    just had to give ...
                  </p>
                </div>
              </div>
            </div>
            <div className=" col-lg-4 col-md-4 col-sm-6 ">
              <div className="card card-div">
                <img
                  src={require("../../Asset/blog/Group 232 (7).png")}
                  className="card-img-top"
                  alt="..."
                />
                <div className="card-body">
                  <h5 className="card-title">
                    Surrealist Storytelling with Cam Collins
                  </h5>
                  <p className="card-text">
                    We’re finalizing our artist list for Spring 2022, but we
                    just had to give ...
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SingleBlog;
